import { Component, EventEmitter, Input, OnInit, Optional, Output, QueryList, Self, ViewChildren } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { IonRadio, IonRadioGroup } from '@ionic/angular/standalone';
import { BehaviorSubject } from 'rxjs';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'fv-radiogroup-multi',
  templateUrl: './radiogroup-multi.component.html',
  styleUrls: ['./radiogroup-multi.component.scss'],
  standalone: true,
  imports: [
    IonicComponentsModule
  ]
})
export class RadiogroupMultiComponent  implements ControlValueAccessor {

  //#region Propiedades

  @Input("label") public label: string
  @Input("value-field") public valueField: string = 'Id'
  @Input("display-field") public displayField: string = 'Text'
  @Input("data-source") public dataSource: BehaviorSubject<any[]>
  @Input("readonly") public readonly: boolean
  @Input("obligatorio") public obligatorio: boolean // Esto es solo para pintar un asterisco, y este campo no se lee de los validadores, sino que hay que establecerlo a mano.
  @ViewChildren(IonRadioGroup) public radios: QueryList<IonRadioGroup>

  private _value: any
  public get value(): any {
    return this._value
  }
  @Input("value") public set value(val: any) {
    if (this._value !== val) {
      this._value = val

      if (this.radios != null) {
        let values: string[] = this._value.toString().split(";")
        this.radios.forEach(p => {
          let radioValue = p["el"].querySelector('ion-radio').value
          if (values.indexOf(radioValue) != -1) {
            p.value = radioValue
          }
        })
      }

    }
  }
  @Output("valueChange") public valueChange = new EventEmitter<any>()
  @Output("valueSelected") public valueSelected = new EventEmitter<{newValue: string, oldValue: string}>()

  //#endregion

  //#region Constructor

  constructor(
    @Self() @Optional() private control: NgControl,
    private util: UtilService
  ) {
    if (this.control != null) this.control.valueAccessor = this
  }

  //#endregion

  //#region Eventos

  public async optionSelected(): Promise<void> {
    let oldValue = this._value
    await this.util.Sleep(1)

    const values = []
    this.radios.forEach(p => {
      if (p.value != null) values.push(p.value)
    })

    if (values.length) {
      this.value = values.join(";")
    } else {
      this.value = ''
    }

    this.valueChange.emit(this.value)
    this.valueSelected.emit({newValue: this.value, oldValue: oldValue})
    this.onChange(this.value)
    this.onTouched()
  }

  public hasValue(value: string): boolean {
    return this._value.toString().split(";").indexOf(value) != -1
  }

  //#endregion

  //#region Reactive Forms

  private onChange = (value: any) => { }
  private onTouched = () => { }

  writeValue(value: any): void {
    this.value = value
    this.valueChange.emit(value)
    this.onChange(value)
  }

  registerOnChange(fn: (value: any) => {}): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn
  }

  public isInvalid(): boolean {
    return this.control ? this.control.invalid : false
  }

  public isTouched(): boolean {
    return this.control ? this.control.touched : false
  }

  //#endregion

}
